<template>
  <v-container class="mt-12 pt-8" style="background:#efefef;">
    <v-row style="background:#efefef;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">receipt</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n.all_invoices_and_billing }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n.see_current_plan_and_invoices }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-left" TITLE>
                            <div style="font-size:11px" :class="`${arabic?'arFont':'enFont'} pb-1`">
                              Selected Account
                            </div>
                            <div v-if="resource.selected_account && resource.selected_account.name" :class="`${arabic?'arFont':'enFont'} font-weight-bold`">
                              {{resource.selected_account.name}}
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-left" TITLE v-if="resource.selected_account &&  resource.selected_account.plans">
                            <v-row class="align-center">
                              <v-col cols="6" class="text-left pa-0" TITLE>
                                <div style="font-size:11px" :class="`${arabic?'arFont':'enFont'} pb-1`">
                                  Current Plans
                                </div>
                              </v-col>
                              <v-col cols="6" class="text-left pa-0" TITLE>
                                <div style="font-size:11px" :class="`${arabic?'arFont':'enFont'} pb-1`">
                                  Price / Month
                                </div>
                              </v-col>
                            </v-row>
                            <div v-for="(plan, p) in resource.selected_account.plans" :key="'plan-'+p">
                              <v-row class="align-center">
                                <v-col cols="6" :class="`${arabic?'arFont':'enFont'} text-left pa-0`" TITLE>
                                  {{plan.label}}
                                </v-col>
                                <v-col cols="6" :class="`${arabic?'arFont':'enFont'} text-left pa-0`" TITLE>
                                  ${{plan.price}}
                                </v-col>
                              </v-row>
                            </div>
                          </v-col>
                          <v-col cols="2" class="text-left" TITLE v-if="resource.selected_account &&  resource.selected_account.services">
                            <v-row class="align-center">
                              <v-col cols="12" class="text-left pa-0" TITLE>
                                <div style="font-size:11px" :class="`${arabic?'arFont':'enFont'} pb-1`">
                                  Current Services
                                </div>
                              </v-col>
                            </v-row>
                            <div v-for="(service, s) in resource.selected_account.services" :key="'service-'+s">
                              <v-row class="align-center">
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} text-left pa-0`" TITLE>
                                  {{service.label}}
                                </v-col>
                              </v-row>
                            </div>
                          </v-col>
                          <v-col cols="2" class="text-left" TITLE>
                            <v-btn color="primary" small>
                              {{i18n.available_services}}
                            </v-btn>
                          </v-col>
                          <v-col cols="2" class="text-left" TITLE>
                            <v-btn color="primary" small>
                              {{i18n.upgrade}}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <Paging 
                              :resourceSettings="resourceSettings" 
                              :resource="resource"
                              @loadResource="loadResource"
                              @pageByNumber="pageByNumber"
                            />
                          </v-col>
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                                <v-expansion-panel-header class="py-0">
                                  <v-row class="pa-0 align-start">
                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-1`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div style="font-size:11px;" class="pb-1">Plan</div>
                                            <div>
                                              {{r.plan.label}}
                                            </div>
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic?'arFont':'enFont'}`">INVOICED ON {{getFormat(r.created_at)}}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} font-weight-bold pb-1`">INVOICE</div>
                                            <div>
                                              {{r.hash}}
                                              <v-btn 
                                                v-clipboard:copy="r.hash"
                                                v-clipboard:success="clipboardSuccessHandler"
                                                v-clipboard:error="clipboardErrorHandler"
                                                color="success" 
                                                x-small 
                                                @click.stop="()=>{}"
                                                v-if="r.hash"
                                                icon>
                                                <v-icon size="10">content_copy</v-icon>
                                              </v-btn>
                                            </div>
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic?'arFont':'enFont'}`">INVOICED ON {{getFormat(r.created_at)}}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-1`">
                                      <div style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} pb-1`">Total</div>
                                      <div v-if="r.total">${{r.total}}</div>
                                    </v-col>
                                    <v-col cols="1" md="1" :class="`${arabic?'arFont':'enFont'} pa-1   text-center`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} pb-1`">Paid</div>
                                            <div>
                                              <v-avatar
                                                size="10"
                                                :color="r.paid?'success':'error'"
                                              >
                                              </v-avatar>
                                            </div>
                                          </span>
                                        </template>
                                        <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.paid">Paid on {{getFormat(r.paid_date)}}</div>
                                        <div :class="`${arabic?'arFont':'enFont'}`" v-if="!r.paid">Last updated on {{getFormat(r.updated_at)}}</div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" md="2" :class="`${arabic?'arFont':'enFont'} pa-1   text-right`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} pb-1`">Paid On</div>
                                            <div>
                                              <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.paid">Paid on {{getFormat(r.paid_date)}}</div>
                                              <div :class="`${arabic?'arFont':'enFont'}`" v-if="!r.paid">
                                                <v-btn 
                                                  color="success" 
                                                  x-small 
                                                  @click.stop="()=>{}"
                                                  text
                                                  >
                                                  pay pending invoice
                                                </v-btn>
                                              </div>
                                            </div>
                                          </span>
                                        </template>
                                        <div :class="`${arabic?'arFont':'enFont'}`" v-if="!r.paid">Last updated on {{getFormat(r.updated_at)}}</div>
                                      </v-tooltip>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content v-if="false">
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1   text-left`">
                                      
                                    </v-col>
                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1   text-left`">
                                      <v-btn color="success" block text @click="updateResource(r)">
                                        <v-icon left>save</v-icon>
                                        <span :class="`${arabic?'arFont':'enFont'}`">
                                          {{ i18n.update }}
                                        </span>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                            
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import Notifications from '@/components/Notifications'
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
const fireapi = 'https://us-central1-innovation-evotik.cloudfunctions.net/main';

export default {
  components: { Paging, Notifications },
  data() {
    return {
      loading:false,
      dialog:false,
      pdfreport:null,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      newDialog:false,
      newUser:{},
      accounts:[],
      search_term:null,
    }
  },
  methods: {
    getInstituteHash(id){
      return this.accounts.filter(x=>x.id==id)[0].hash
    },
    getFormat(d){
      return format(d)
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/invoices', page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/invoices' + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      if(this.selectedAccount && this.selectedAccount.id) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`
      }
      if(this.search_term) {
        filter += `&filter[search]=${this.search_term}`
      }
      return filter
    },
    async filterItems(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/invoices' + '?' + this.buildFilter()})
          console.log(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/invoices' + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        // console.log(r)
        await this.$store.dispatch('putResource', {resource:'/invoices' + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    
    async addUser() {
      return new Promise(async (res, rej)=>{
        if(!this.newUser.name) {
          this.$emit('snackbarNotification', `${this.i18n[name_required]}`, 'error')
          return false
        }
        if(!this.newUser.email) {
          this.$emit('snackbarNotification', `${this.i18n[email_required]}`, 'error')
          return false
        }
        if(!this.newUser.password) {
          this.$emit('snackbarNotification', `${this.i18n[password_required]}`, 'error')
          return false
        }
        if(!this.newUser.account_id) {
          this.newUser.account_id = this.accounts[0].id
        }
        this.loading = true
        let user = this.newUser
        try {
          let a = await axios.post(`${fireapi}/registerNewUser`, user, {headers:headers}).then(x=>x.data)
          // console.log(a)
          if(!a.error) {
            this.loading = false;
            this.error = null
            let nu = {
              'provider': a.user.providerData[0].providerId,
              'name': a.user.displayName,
              'email': a.user.email,
              'phone': user.phone,
              'image': a.user.photoURL,
              'verified_email': a.user.emailVerified,
              'uid': a.user.uid,
              'account_id' : user.account_id
            }
            let r = await this.$store.dispatch('postResource', {resource:'/user', value:nu})
            if(!r.error) {
              this.loading = false
              this.$emit('snackbarNotification', `${this.i18n.accountCreated}`, 'success')
            }
          } else {
            this.loading = false;
            this.$emit('snackbarNotification', `${this.i18n[a.error.message] ? this.i18n[a.error.message] : a.error.message}`, 'error')
          }
          this.newDialog = false
          await this.loadResource()
        } catch (error) {
        }
      })
    }
  },
  computed:{
    selectedAccount(){
      return this.$store.state.selectedAccount
    },
    checkDisabled(){
      if(this.user.role == 'master') {
        return false
      } else {
        return this.resource.tokens > 0 ? false : true
      }
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
  },
}
</script>

<style>

</style>